export const TipoParticipante = Object.freeze({
  COLABORADOR: 1,
  VAGA_ABERTA: 2,
  TERCEIRO: 3,
  VAGA_NOVA: 4
});

export const TipoParticipanteLabel = Object.freeze({
  [TipoParticipante.COLABORADOR]: "Colaborador interno",
  [TipoParticipante.VAGA_ABERTA]: "Vagas em aberto",
  [TipoParticipante.TERCEIRO]: "Terceiros",
  [TipoParticipante.VAGA_NOVA]: "Novas vagas",
  COLABORADOR: "Colaborador interno",
  VAGA_ABERTA: "Vagas em aberto",
  TERCEIRO: "Terceiros",
  VAGA_NOVA: "Novas vagas"
});

// Colunas exibidas no histórico (HistoryListModal) de cada vínculo do participante.
export const PerfilHistoryColumns = Object.freeze([
  { key: "senioridade", name: "Senioridade" },
  { key: "especialidade", name: "Especialidade" }
]);

export const BudgetKeyHistoryColumns = Object.freeze([
  { key: "posicao", name: "Posição" }
]);

export const CentroCustoHistoryColumns = Object.freeze([
  { key: "nome", name: "Centro de Custo" }
]);
